import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { ParallelAiState } from "@/types/parallelAi";

import { parallelAi } from "./parallelAi.api";

const initialState: ParallelAiState = {
	parallelAi: {
		data: [],
		meta: {
			page: 1,
			limit: 15,
			itemCount: 15,
			pageCount: 1,
			hasPreviousPage: false,
			hasNextPage: false,
		},
	},
};

export const parallelAiSlice = createSlice({
	name: "parallelAi",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			parallelAi.endpoints.getParallelAiLists.matchFulfilled,
			(state, { payload }) => {
				if (payload) {
					state.parallelAi = payload;
				}
			}
		);
	},
});

export const parallelAiSliceReducer = parallelAiSlice.reducer;
export const parallelAiSliceSelector = (state: RootState) => state[parallelAiSlice.name];
